// Keep critical routes for login/logout synchronous, to avoid chunk loading errors
import Loading from 'src/views/Miscellaneous/Loading.vue'

const routes = [
  {
    path: '/loading',
    name: 'loading',
    component: Loading,
  }
]

export default routes
